import masonry from 'alpinejs-masonry'

document.addEventListener('alpine:init', () => {
    Alpine.plugin(masonry);
});

Alpine.data("toggleable", (disableScroll = false) => ({
    show: false,

    open() {
        if (this.show) return;

        if (this.$refs.trigger != null) {
            this.$refs.trigger.focus();
        }

        this.show = true;

        if (disableScroll) {
            setTimeout(() => {
                document.body.style.overflow = "hidden";
            });
        }
    },

    close(focusAfter) {
        if (!this.show) return;

        this.show = false;

        if (disableScroll) {
            document.body.style.overflow = "";
        }

        focusAfter && focusAfter.focus();
    },

    toggle() {
        if (this.show) {
            this.close();
        } else {
            this.open();
        }
    },

    run(method) {
        method = typeof method === "string" ? method : "toggle";

        switch (method) {
            case "open":
                this.open();
                break;
            case "close":
                this.close();
                break;
            case "toggle":
                this.toggle();
                break;
        }
    },
}));

Alpine.data("dialog", () => ({
    open: false,

    toggle() {
        if (this.open) {
            return this.close();
        }

        if (this.$refs.trigger != null) {
            this.$refs.trigger.focus();
        }

        this.$refs.dialog.showModal();
        this.open = true;
    },

    close(focusAfter, event) {
        if (!this.open) return;

        if (event != null && event.target !== this.$refs.dialog) return;

        this.$refs.dialog.close();
        this.open = false;

        focusAfter && focusAfter.focus();
    },

    run(method) {
        method = typeof method === "string" ? method : "toggle";

        switch (method) {
            case "toggle":
                this.toggle();
                break;
            case "open":
                this.$refs.dialog.showModal();
                this.open = true;
                break;
            case "close":
                this.close();
                break;
        }
    },
}));

Alpine.data("drawer", () => ({
    open: false,

    toggle() {
        if (this.open) {
            return this.close();
        }

        if (this.$refs.trigger != null) {
            this.$refs.trigger.focus();
        }

        this.open = true;
        document.body.style.overflow = "hidden";
    },

    close(focusAfter) {
        if (!this.open) return;

        this.open = false;
        document.body.style.overflow = "";

        focusAfter && focusAfter.focus();
    },

    run(method) {
        method = typeof method === "string" ? method : "toggle";

        switch (method) {
            case "toggle":
                this.toggle();
                break;
            case "open":
                this.open = true;
                break;
            case "close":
                this.close();
                break;
        }
    },
}));

Alpine.data("tab", (tab = null, hasInit = true, hasChange = true) => ({
    tab: tab,

    init() {
        if (hasInit && window.location.hash) {
            this.change(window.location.hash.substring(1));
        }
    },

    change(tab, href) {
        if (hasChange) {
            this.tab = tab;

            if (typeof href === 'string' && href.startsWith('#')) {
                history.replaceState(undefined, undefined, href);
            }
        }
    },
}));
